import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "../Auth/Login";
import "./ERPLaunch.css";

function ERPLaunchSAP({ setUserRights }) {
  const brandNavy = "#344e66";

  const features = [
    { icon: "ri-bar-chart-fill", title: "Analytics", desc: "Real-time Reports" },
    { icon: "ri-team-fill", title: "Human Resources", desc: "Staff & Payroll" },
    { icon: "ri-building-fill", title: "Operations", desc: "Multi-branch Control" },
    { icon: "ri-database-2-fill", title: "Database", desc: "Centralized Data" },
  ];

  return (
    <div className="erp-launch-container">
      {/* Subtle Background Elements */}
      <div className="erp-bg-decor-1"></div>
      <div className="erp-bg-decor-2"></div>

      <div className="erp-content container-xl">
        {/* Left Section: Hero Information */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="erp-left"
        >
          {/* Brand Badge */}
          <div className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill bg-white shadow-sm border mb-3">
            <span
              className="rounded-circle"
              style={{
                width: "8px",
                height: "8px",
                backgroundColor: "#22c55e",
              }}
            ></span>
            <span className="small fw-semibold text-muted text-uppercase tracking-wide">
              Enterprise Resource Planning
            </span>
          </div>

          {/* Main Titles */}
          <h1 className="display-4 fw-extrabold mb-3" style={{ color: brandNavy, letterSpacing: "-0.02em" }}>
            Paupet Soft <br />
            <span className="text-secondary opacity-75 fw-normal fs-2">
              Management Portal
            </span>
          </h1>

          <p className="text-muted fs-6 mb-4 lead-text" style={{ maxWidth: "460px" }}>
            A unified workspace tailored for academic and institutional operational excellence. Access modules securely from anywhere.
          </p>

          {/* Feature Grid */}
          <div className="feature-grid mt-2 mb-4">
            {features.map((item, idx) => (
              <div key={idx} className="feature-card">
                <div className="feature-icon" style={{ color: brandNavy }}>
                  <i className={item.icon}></i>
                </div>
                <div>
                  <h6 className="mb-0 fw-bold" style={{ color: brandNavy }}>
                    {item.title}
                  </h6>
                  <small className="text-muted">{item.desc}</small>
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Right Section: Embedded Login */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="erp-right"
        >
          <div className="login-wrapper">
            <Login setUserRights={setUserRights} />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default ERPLaunchSAP;